module.exports = __webpack_public_path__ + "static/media/logo.65b8b572.png";